import axios from "functions/axios";

export const ListActiveFacultiesFieldsAPI = () =>
  axios.get("education/faculties/lists/").then((res) => res.data);

export const FacultyListByDegreeAPI = () =>
  axios.get("education/faculties/lists_by_degree/").then((res) => res.data);

export const ListFacultiesAPI = ({ page = 1, page_size = 15, search = "" } = {}) =>
  axios
    .get("education/admin/faculties/list_create/", {
      params: {
        page,
        page_size,
        search,
      },
    })
    .then((res) => res.data);

export const CreateFacultyAPI = (payload) =>
  axios.post("education/admin/faculties/list_create/", payload).then((res) => res.data);

export const UpdateFacultyAPI = ({ pk, data }) =>
  axios.put(`education/admin/faculties/update_delete/${pk}/`, data).then((res) => res.data);

export const DeleteFacultyAPI = (pk) =>
  axios.delete(`education/admin/faculties/update_delete/${pk}/`).then((res) => res.data);

export const ListFacultyFieldsAPI = ({ faculty, page = 1, page_size = 15, search = "" } = {}) =>
  axios
    .get("education/admin/field_of_study/list_create/", {
      params: {
        faculty,
        page,
        page_size,
        search,
      },
    })
    .then((res) => res.data);

export const CreateFacultyFieldsAPI = (payload) =>
  axios.post("education/admin/field_of_study/list_create/", payload).then((res) => res.data);

export const UpdateFacultyFieldsAPI = ({ pk, data }) =>
  axios.put(`education/admin/field_of_study/update_delete/${pk}/`, data).then((res) => res.data);

export const DeleteFacultyFieldsAPI = (pk) =>
  axios.delete(`education/admin/field_of_study/update_delete/${pk}/`).then((res) => res.data);
